import React, { FC, memo } from 'react';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

interface IProps extends WithStyles<typeof styles> {
  format: 'desktop' | 'mobile';
}

interface IImageProps {
  className: string;
  style: object;
}

const BG_COLOR = '#85c5dc';
const SVG_PATH = '/images/walkthrough/step-1.svg';

const DESKTOP_HEIGHT = 450;
const DESKTOP_SVG_WIDTH = 462;
const DESKTOP_SVG_HEIGHT = 710;
const DESKTOP_STARTING_OFFSET = 100;
const DESKTOP_ENDING_OFFSET = -200;

const MOBILE_HEIGHT = 250;
const MOBILE_SVG_WIDTH = 222;
const MOBILE_SVG_HEIGHT = 510;
const MOBILE_STARTING_OFFSET = 100;
const MOBILE_ENDING_OFFSET = -60;

const styles = (theme: Theme) =>
  createStyles({
    '@global @keyframes step-1-desktop': {
      '0%': { transform: `translateX(-50%) translateY(${DESKTOP_STARTING_OFFSET}px)` },
      '10%': { transform: `translateX(-50%) translateY(${DESKTOP_ENDING_OFFSET}px)` },
      '20%': {
        transform: `translateX(-50%) translateY(${DESKTOP_ENDING_OFFSET}px) scale(1.2) translateX(-10%)`,
      },
      '100%': {
        transform: `translateX(-50%) translateY(${DESKTOP_ENDING_OFFSET}px) scale(1.2) translateX(-10%)`,
      },
    },
    '@global @keyframes step-1-mobile': {
      '0%': { transform: `translateX(-50%) translateY(${MOBILE_STARTING_OFFSET}px)` },
      '10%': { transform: `translateX(-50%) translateY(${MOBILE_ENDING_OFFSET}px)` },
      '20%': {
        transform: `translateX(-50%) translateY(${MOBILE_ENDING_OFFSET}px) scale(1.2) translateX(-10%)`,
      },
      '100%': {
        transform: `translateX(-50%) translateY(${MOBILE_ENDING_OFFSET}px) scale(1.2) translateX(-10%)`,
      },
    },
    root: {
      position: 'relative',
      overflow: 'hidden',
      marginBottom: theme.spacing(3),
      backgroundColor: BG_COLOR,
    },
    image: {
      position: 'absolute',
      top: 0,
      left: '50%',
      backgroundImage: `url(${SVG_PATH})`,
      backgroundRepeat: 'no-repeat',
      transform: 'translateX(-50%)',
      animationDelay: '1s',
      animationDuration: '5s',
      animationTimingFunction: 'ease-in-out',
      animationIterationCount: 'infinite',
    },
  });

const Image: FC<IImageProps> = memo(
  function MemoImage({ className, style }) {
    return <div className={className} style={style} />;
  },
  () => true,
);

const StepOne: FC<IProps> = ({ classes, format }) => {
  let height = DESKTOP_HEIGHT;
  let imageStyle = {
    width: DESKTOP_SVG_WIDTH,
    height: DESKTOP_SVG_HEIGHT,
    animationName: 'step-1-desktop',
    transform: `translateX(-50%) translateY(${DESKTOP_STARTING_OFFSET}px)`,
  };

  if (format === 'mobile') {
    height = MOBILE_HEIGHT;
    imageStyle = {
      width: MOBILE_SVG_WIDTH,
      height: MOBILE_SVG_HEIGHT,
      animationName: 'step-1-mobile',
      transform: `translateX(-50%) translateY(${MOBILE_STARTING_OFFSET}px)`,
    };
  }

  return (
    <div className={classes.root} style={{ height }}>
      <Image className={classes.image} style={imageStyle} />
    </div>
  );
};

export default withStyles(styles)(StepOne);
